import Content from './content.view';

export default Content;
